import React from 'react'
import * as styles from './index.module.css'
import { GatsbyImage } from 'gatsby-plugin-image'
import { GradientBorder } from '../commons'
import Button from '../Button/'
import Link from '../Link'

const OsFeatures = (props) => {
  const attrs = props.subtitle && props.subtitle.subtitle.split('\n')
  const { ctaText, ctaUrl } = props
  return (
    <div className="wrapper">
      <div className={styles.container}>
        <GradientBorder height="1px" />
        <h2 className={styles.title}>{props.title}</h2>
        <div className={styles.features}>
          {props.components.map((comp, idx) => (
            <div className={styles.feature} key={idx}>
              <GatsbyImage
                image={comp.gatsbyImageData}
                className={styles.featureImage}
                alt={comp.image?.description}
              />
              <h3 className={styles.featureTitle}>{comp.title}</h3>
              <div className={styles.featureSubtitle}>
                {comp.subtitle.subtitle}
              </div>
            </div>
          ))}
        </div>
        {ctaUrl && ctaText && (
          <div className={styles.talkToSales}>
            <Link to={ctaUrl}>
              <Button className={styles.tts}>{ctaText}</Button>
            </Link>
          </div>
        )}
      </div>
    </div>
  )
}

export default OsFeatures
